module.exports = __webpack_public_path__ + "img/1517653005.12803e4a.jpg";